import { Result } from 'neverthrow'
import { DynamicFunctionNode, ExpressionNode } from '../scriptcompiler/AstNode'
import { BaseRunContext } from '../scriptevaluator/RunContext'
import { CalcRuntimeError, CalcRuntimeExprValue } from '../scriptevaluator/RuntimeTypes'

export const functionNodeTypes = {
	Abs: 'Abs',
	AnySelected: 'AnySelected',
	BMIInterpretation: 'BMIInterpretation',
	ConceptId: 'ConceptId',
	DirId: 'DirId',
	DirValueId: 'DirValueId',
	DirValidity: 'DirValidity',
	Changed: 'Changed',
	Value: 'Value',
	Round: 'Round',
	Power: 'Power',
	SubconceptIds: 'SubconceptIds',
	HasAnyValue: 'HasAnyValue',
	IsBMI: 'IsBMI',
	IsComorbid: 'IsComorbid',
	IsPcp: 'IsPcp',
	BPSystolic: 'BPSystolic',
	BPDiastolic: 'BPDiastolic',
	BPIsElevated: 'BPIsElevated',
	Titles: 'Titles',
} as const

export type HelperFunctionNodeType = typeof functionNodeTypes[keyof typeof functionNodeTypes]

export interface HelperFunction {
	tokenName: string
	nodeType: HelperFunctionNodeType
	evaluate(
		node: DynamicFunctionNode,
		evaluateExpressionNode: (n: ExpressionNode) => Result<CalcRuntimeExprValue, CalcRuntimeError>,
		context: BaseRunContext,
	): Result<CalcRuntimeExprValue, CalcRuntimeError>
}
